import CryptoJS from "crypto-js";

export const encode = (data) => {
  return CryptoJS.AES.encrypt(
    JSON.stringify(data),
    process.env.REACT_APP_DEV_SECRET_KEY
  ).toString();
};

export const decode = (data) => {
  return CryptoJS.AES.decrypt(
    data,
    process.env.REACT_APP_DEV_SECRET_KEY
  ).toString(CryptoJS.enc.Utf8);
};
